import React from "react";

export default function DeniedMsg({ country = "" }) {
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <h1>
            4<span>0</span>3
          </h1>
        </div>
        <h2>
          This site is currently unavailable{" "}
          {country !== "error" && country !== "" ? (
            <>
              for the Country <strong>{country}</strong>
            </>
          ) : (
            "due to a location detection error."
          )}
        </h2>
      </div>
    </div>
  );
}
